import React from 'react';

function InsightIcons(props) {
  return (
    <div className='icons_item d-flex align-items-center'>
      <div className='svg'>{props.icon}</div>
      <div className='d-flex-col justify-content-center'>
        <h3>{props.text}</h3>
        <p className='text-gray'>{props.text2}</p>
      </div>
    </div>
  );
}

export default InsightIcons;
